// extracted by mini-css-extract-plugin
module.exports = {"__btn__floating":"ButtonFloating___btn__floating__30ksU"};